module.exports = __webpack_public_path__ + "static/pic06-5c95ef56739b64575a417df34e70b7d8.jpg";